"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const file_1 = require("../type-checking/file");
class FileFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, file_1.isFileFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => [];
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, file_1.isOptimizedFileFieldValue)(fieldValue);
        };
        this.getValueFromOptimized = (fieldValue) => {
            return fieldValue.filter(({ handle }) => handle).map(file_1.optimizedFileToFile);
        };
    }
}
exports.FileFieldValueGetter = FileFieldValueGetter;
